/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-parameter-properties */
import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import { Payment } from '../../external_api/model/paypal';
import { ExternalAPI } from '../../external_api/service/external-api.service';
import { Cookie } from '../../utils/cookie';
import { TmCart, TmCartOrderSummary } from '../model/cart';
import { TmErrorInfo } from '../model/error';
import { TmEasyPaySchedule, TmOrder, TmOrderHistoryDetail, TmOrderHistoryList } from '../model/order';
import { TmModifyOrderRequest, TmOrderRequest } from '../model/request/order-request';

import { ApiBase } from './apibase.service';


export class OrderBase extends ApiBase {
    private cookie = new Cookie();
    protected acctBaseUrlWithEdp =
        this.cookie.UserAccessToken != undefined && this.cookie.UserAccessToken.Edp != undefined
            ? this.baseUrl + '/accounts/' + this.cookie.UserAccessToken.Edp
            : this.baseUrl;
    protected orderBaseUrl = this.acctBaseUrlWithEdp + '/orders';

    constructor(protected http: Http) {
        super(http);
    }
}(OrderBase as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Order extends OrderBase {
    constructor(protected http: Http) {
        super(http);
    }

    /** @description Returns detailed information of given orderno
     *   @return {TmOrderHistoryDetail}
     */
    get(orderNo: string, validateOrder: boolean): Observable<TmOrderHistoryDetail> {
        const url = `${this.orderBaseUrl}/${orderNo}?validate=` + validateOrder;

        return this.http
            .get(url, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmOrderHistoryDetail)
            .catch(this.handleError);
    }

    /** @description Place order.
     *   @return {TmOrder}
     */
    post(orderReq: TmOrderRequest): Observable<TmOrder> {
        //paypal process
        if (orderReq.PaypalPayerId != null) {
            const paypalSvc = new ExternalAPI(this.http);
            return paypalSvc.paypal_Payment
                .execute()
                .map((resp) => resp as Payment)
                .flatMap((resp) => {
                    const paypalOrderId = resp.transactions[0].related_resources[0].order.id;
                    orderReq.PaypalTransactionId = paypalOrderId;

                    return this.http
                        .post(this.orderBaseUrl, orderReq, { headers: this.userTokenJsonTypeHeader })
                        .map((resp) => resp.json() as TmOrder)
                        .catch(this.handleError);
                });
        } else {
            return this.http
                .post(this.orderBaseUrl, orderReq, { headers: this.userTokenJsonTypeHeader })
                .map((resp) => resp.json() as TmOrder)
                .catch(this.handleError);
        }
    }
}(Order as any).ctorParameters = function () { return [ { type: Http } ]; }


export class OrderList extends OrderBase {
    constructor(protected http: Http) {
        super(http);
    }
    /** @description Returns list of orders
     *   @return {TmOrderHistoryList}
     */
    get(
        page: number,
        pageSize: number,
        fromDate: string,
        toDate: string,
        validate: boolean,
    ): Observable<TmOrderHistoryList> {
        const urlParams: URLSearchParams = new URLSearchParams();

        if (page > 0) urlParams.set('page', page.toString());

        if (pageSize > 0) urlParams.set('pageSize', pageSize.toString());

        if (fromDate != null && fromDate.trim().length > 0) urlParams.set('fromDate', fromDate);

        if (toDate != null && toDate.trim().length > 0) urlParams.set('toDate', toDate);

        //validate order for modification
        urlParams.set('validate', validate.toString());

        return this.http
            .get(this.orderBaseUrl, { headers: this.userTokenJsonTypeHeader, search: urlParams })
            .map((resp) => resp.json() as TmOrderHistoryList)
            .catch(this.handleError);
    }
}(OrderList as any).ctorParameters = function () { return [ { type: Http } ]; }


export class OrderReview extends OrderBase {
    constructor(protected http: Http) {
        super(http);
    }
    /** @description Get order review details before placing an order
     *   @return {TmCart}
     */
    get(): Observable<TmCart> {
        return this.http
            .get(this.acctBaseUrlWithEdp + '/orderreview', { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart)
            .catch(this.handleError);
    }
}(OrderReview as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Order_EasypaySchedule extends OrderBase {
    constructor(protected http: Http) {
        super(http);
    }
    /** @description Get order review details before placing an order
     *   @return {TmEasyPaySchedule[]}
     */
    get(): Observable<TmEasyPaySchedule[]> {
        return this.http
            .get(this.acctBaseUrlWithEdp + '/easypayschedule', { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmEasyPaySchedule[])
            .catch(this.handleError);
    }
}(Order_EasypaySchedule as any).ctorParameters = function () { return [ { type: Http } ]; }


export class OrderedCart extends OrderBase {
    constructor(protected http: Http) {
        super(http);
    }
    /** @description Get ordered cart details for given cartguids
     *   @return {TmCart}
     */
    get(): Observable<TmCart> {
        const cartGuids = new Cookie().OrderedCartGuid;
        return this.http
            .get(this.acctBaseUrlWithEdp + '/orderedcart/' + cartGuids, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCart)
            .catch(this.handleError);
    }
}(OrderedCart as any).ctorParameters = function () { return [ { type: Http } ]; }


export class ModifyOrder extends OrderBase {
    constructor(protected http: Http) {
        super(http);
    }

    /** @description Recalculate cart order summary for given modified order
     *   @return {TmCartOrderSummary}
     */
    reviewCartOrderSummary(orderNo: string, orderReq: TmModifyOrderRequest): Observable<TmCartOrderSummary> {
        const url = `${this.orderBaseUrl}/${orderNo}/review`;

        return this.http
            .put(url, orderReq, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmCartOrderSummary)
            .catch(this.handleModifyOrderError);
    }

    /** @description Modify order
     *   @return {TmCartOrderSummary}
     */
    put(orderNo: string, orderReq: TmModifyOrderRequest): Observable<TmOrder> {
        const url = `${this.orderBaseUrl}/${orderNo}`;
        return this.http
            .put(url, orderReq, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmOrder)
            .catch(this.handleModifyOrderError);
    }

    private handleModifyOrderError(error: Response) {
        if (error.status === 401) {
            const cookie = new Cookie();
            cookie.TargetUrl = window.location.href;
            window.location.href = '/pages/signin';
        } else {
            const errorInfo: TmErrorInfo = (error.json() as TmErrorInfo[])[0];
            let errorMessage = errorInfo.Message;

            switch (errorInfo.Area) {
                case 'ModifyOrderPromocode':
                    errorMessage = 'Promocode:' + errorInfo.Message;
                    break;
                case 'ModifyOrderCheckoutLimit':
                    errorMessage = 'Checkoutlimit:' + errorInfo.Message;
                    break;
                default:
                    errorMessage = errorInfo.Message;
            }
            return Observable.throw(errorMessage);
        }
    }
}(ModifyOrder as any).ctorParameters = function () { return [ { type: Http } ]; }

export class OrderInvoice extends OrderBase {
    constructor(protected http: Http) {
        super(http);
    }

    /** @description Returns order invoice
     *   @return {TmOrderHistoryDetail}
     */
    get(orderNo: string): Observable<TmOrderHistoryDetail> {
        const url = `${this.orderBaseUrl}/${orderNo}/invoice`;

        //prevent loading french api
        const url2 = url.replace('/v2/fr/', '/v2/en/');

        return this.http
            .get(url2, { headers: this.userTokenJsonTypeHeader })
            .map((resp) => resp.json() as TmOrderHistoryDetail)
            .catch(this.handleError);
    }
}(OrderInvoice as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/order.service.ts